import {useEffect} from 'react';

import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';
import {pushAnalyticsEvent} from '@flexinet/analytics-components';
import {signOut} from 'aws-amplify/auth';

export const SignOutPage = () => {
    useEffect(() => {
        const doSignOut = async () => {
            signOut()
                .then(() => {
                    pushAnalyticsEvent('sign_out')
                    window.location.href = '/';
                });
        };

        doSignOut();
    }, []);

    return (
        <Center>
            <PlatformLoader/>
        </Center>
    );
};
